import React, { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { status as statusMock } from "@planzone/dto";

import { Status } from "@planzone/dto";
import { ColorPicker } from "@common/colorPicker";
import { VisibilitySwitch } from "@common/visibilitySwitch";
import { Props } from "./types";
import styles from "./styles.scss";
import icon from "./icon.svg";

function Form(props: Props) {
  const { t } = useTranslation();
  const [status, setStatus] = React.useState<Status>(statusMock);

  return (
    <div className={styles.form}>
      <VisibilitySwitch
        renderChildren={(isVisible, show, hide) => (
          <Fragment>
            <div className={styles.iconBox}>
              <img
                className={styles.icon}
                src={icon}
                alt="icon"
                onClick={isVisible ? hide : show}
              />
              {isVisible && (
                <div className={styles.colorPicker}>
                  <ColorPicker
                    color={status.color}
                    pick={(color) => setStatus({ ...status, color })}
                  />
                </div>
              )}
            </div>
            <div className={styles.group}>
              <input
                type="text"
                className={styles.input}
                placeholder={t("createStatus.namePlaceholder")}
                value={status.label}
                onChange={({ target }) => {
                  setStatus({ ...status, label: target.value });
                }}
                onKeyUp={({ key }) => {
                  if (key === "Enter" && !props.isRequestPending) {
                    props.submit(status);
                    setStatus({ ...status, label: "", color: "" });
                    hide();
                  }
                }}
                autoFocus
              />
            </div>
          </Fragment>
        )}
      />
    </div>
  );
}

export { Form };
